/* ══════════════════════════════════════════════════════════════
   CART DRAWER ENHANCE v2 — Cockpit Night
   • Progress livraison en haut du drawer
   • Délégation document pour le bouton checkout
   • Walker text nodes pour remplacer "Total estimé" → "Sous-total"
   ══════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  window.PP_CART_CONFIG = window.PP_CART_CONFIG || {};
  var CONFIG = {
    freeShippingThreshold: window.PP_CART_CONFIG.freeShippingThreshold || 4000,
    checkoutMode: window.PP_CART_CONFIG.checkoutMode || 'direct',
    debug: window.PP_CART_CONFIG.debug || false,
    texts: {
      progressNotReached: 'Plus que {amount} pour la livraison offerte',
      progressReached: 'Livraison offerte débloquée !',
      subtotalLabel: 'Sous-total'
    }
  };

  function log() {
    if (CONFIG.debug && window.console) console.log.apply(console, ['[cart-drawer]'].concat([].slice.call(arguments)));
  }

  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + '€';
  }

  function parsePriceFromDOM(el) {
    if (!el) return 0;
    var text = (el.textContent || '').replace(/\s/g, '');
    var m = text.match(/(\d+[.,]?\d*)/);
    if (!m) return 0;
    var val = parseFloat(m[1].replace(',', '.'));
    if (isNaN(val)) return 0;
    return Math.round(val * 100);
  }

  function getCartTotal(drawer) {
    if (!drawer) return 0;
    var totalEl = drawer.querySelector(
      '.pp-totals-value, .totals__subtotal-value, .totals__total-value, .totals .price, ' +
      '.totals [class*="total-value"], .totals strong, .totals .price-item'
    );
    return parsePriceFromDOM(totalEl);
  }

  /* ─── PROGRESS BAR (haut du drawer uniquement) ── */
  function injectProgressBar(drawer) {
    if (!drawer || drawer.classList.contains('is-empty')) return;
    if (drawer.querySelector('.pp-shipping-progress')) return;

    /* Insère la barre au DÉBUT de #CartDrawer-CartItems (zone scrollable) */
    var contents = drawer.querySelector('#CartDrawer-CartItems');
    if (!contents) return;

    var bar = document.createElement('div');
    bar.className = 'pp-shipping-progress';
    bar.innerHTML =
      '<div class="pp-shipping-progress__text"></div>' +
      '<div class="pp-shipping-progress__bar">' +
        '<div class="pp-shipping-progress__fill"></div>' +
      '</div>';

    contents.insertBefore(bar, contents.firstChild);
  }

  function updateProgress() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    var total     = getCartTotal(drawer);
    var threshold = CONFIG.freeShippingThreshold;
    var progress  = Math.min(100, (total / threshold) * 100);
    var remaining = Math.max(0, threshold - total);
    var reached   = total >= threshold && total > 0;

    log('total:', total, 'progress:', progress + '%', 'reached:', reached);

    var bar = drawer.querySelector('.pp-shipping-progress');
    if (bar) {
      var fill = bar.querySelector('.pp-shipping-progress__fill');
      var text = bar.querySelector('.pp-shipping-progress__text');
      if (fill) {
        fill.style.width = progress + '%';
        /* Fallback via attribut direct si style inline bloqué */
        fill.setAttribute('data-width', progress);
        fill.parentNode.style.setProperty('--bar-progress', progress + '%');
      }
      if (text) {
        text.innerHTML = reached
          ? '🎉 <strong>' + CONFIG.texts.progressReached + '</strong>'
          : CONFIG.texts.progressNotReached.replace('{amount}', '<strong>' + money(remaining) + '</strong>');
      }
      bar.classList.toggle('pp-shipping-progress--reached', reached);
    }
  }

  /* ─── REMPLACEMENT "Total estimé" → "Sous-total" ── */
  function replaceEstimatedLabel(drawer) {
    if (!drawer) return;
    var footer = drawer.querySelector('.drawer__footer, .cart-drawer__footer');
    if (!footer) return;

    var walker = document.createTreeWalker(
      footer,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: function (node) {
          var t = (node.nodeValue || '').trim();
          if (!t) return NodeFilter.FILTER_REJECT;
          if (/[€$£¥]/.test(t)) return NodeFilter.FILTER_REJECT;
          if (/^\d[\d\s.,]*$/.test(t)) return NodeFilter.FILTER_REJECT;
          if (/estim/i.test(t) || /subtotal/i.test(t) || /sous[-\s]?total/i.test(t) || /^total$/i.test(t.toLowerCase())) {
            return NodeFilter.FILTER_ACCEPT;
          }
          return NodeFilter.FILTER_REJECT;
        }
      }
    );

    var node;
    var nodesToReplace = [];
    while ((node = walker.nextNode())) nodesToReplace.push(node);
    nodesToReplace.forEach(function (n) { n.nodeValue = CONFIG.texts.subtotalLabel; });
  }

  /* ─── DÉLÉGATION BOUTON CHECKOUT ── */
  var checkoutDelegated = false;
  function delegateCheckoutClick() {
    if (checkoutDelegated) return;
    checkoutDelegated = true;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.cart__checkout-button, button[name="checkout"], input[name="checkout"]');
      if (!btn) return;
      if (!btn.closest('cart-drawer')) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      if (CONFIG.checkoutMode === 'cart') {
        window.location.href = '/cart';
      } else {
        window.location.href = '/checkout';
      }
    }, true);
  }

  function updateEmptyState(drawer) {
    if (!drawer) return;
    var items = drawer.querySelectorAll('.cart-item, [id^="CartDrawer-Item"], cart-drawer-items li');
    if (items.length > 0 && drawer.classList.contains('is-empty')) {
      drawer.classList.remove('is-empty');
    }
  }

  function enhanceDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    updateEmptyState(drawer);
    injectProgressBar(drawer);
    replaceEstimatedLabel(drawer);
    updateProgress();
  }

  function setupObserver() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.dataset.ppObserved === '1') return;
    drawer.dataset.ppObserved = '1';

    if (!window.MutationObserver) return;

    var pending = false;
    var observer = new MutationObserver(function (muts) {
      var fromUs = muts.every(function (m) {
        return [].every.call(m.addedNodes, function (n) {
          if (n.nodeType !== 1) return true;
          return n.classList && n.classList.contains('pp-shipping-progress');
        });
      });
      if (fromUs) return;
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { enhanceDrawer(); pending = false; });
    });
    observer.observe(drawer, { childList: true, subtree: true });

    var classObs = new MutationObserver(function () {
      if (drawer.classList.contains('active') || drawer.classList.contains('is-open')) {
        enhanceDrawer();
      }
    });
    classObs.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  function setupEvents() {
    document.addEventListener('cart:updated', function () { setTimeout(enhanceDrawer, 80); });
    document.addEventListener('cart:refresh', function () { setTimeout(enhanceDrawer, 80); });
    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(enhanceDrawer, 80); });
    }
  }

  function init() {
    delegateCheckoutClick();
    enhanceDrawer();
    setupObserver();
    setupEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  setTimeout(init, 400);
  setTimeout(init, 1200);
  setTimeout(init, 2500);
})();